
import CmsRequest from "./models/cmsRequest";
import CmsH5Request from "./models/cmsH5Request";
export default {CmsRequest,CmsH5Request};
